import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Collapse, Glyphicon, Panel, Row } from 'react-bootstrap';

import DurationBarChartContainer from '../Containers/DurationBarChartContainer';
import HitCountChartContainer from '../Containers/HitCountChartContainer';
import MetricsTableContainer from '../Containers/MetricsTableContainer';
import SourceAttributeCountChartContainer
  from '../Containers/SourceAttributeCountChartContainer';
import SourceCountChartContainer from '../Containers/SourceCountChartContainer';
import { metrics as constants, unicode } from '../helpers';

const BuildMetricsComponent = ({
  baselineBuildType,
  onShowStatsModal,
  metricsExpanded,
  setMetricsExpanded,
  latestMetricsOnly,
  setLatestMetricsOnly,
  concerningMetricsOnly,
  setConcerningMetricsOnly,
  refreshScans,
  metrics,
  metricsLoaded,
  onOpenConfirm,
  ccfNcfOrder,
  setShowBuildComplement,
  showSources,
  setShowSources
}) => {
  const badge = constants.getMetricBadge(metrics, metricsLoaded, ccfNcfOrder);
  const hitCountStyle = constants.getHitCountStyle(
    metrics,
    ccfNcfOrder
  );
  const showExpected = baselineBuildType === 'Expected';

  return (
    <Panel bsStyle={badge.style}>
      <Panel.Heading>
        <Panel.Title>
          <div className="flex">
            <div className="flex-grow">
              <Glyphicon
                id="metrics-expander"
                glyph={metricsExpanded ? 'minus' : 'plus'}
                onClick={() => setMetricsExpanded(!metricsExpanded)}
                style={{ marginRight: '10px', cursor: 'pointer' }}
              />
              <span>Case Metrics</span>
            </div>
            <a
              id="show-stats-modal"
              onClick={onShowStatsModal}
              style={{ margin: '0 10px' }}
            >
              Show Statistics
            </a>
            <label>
              Only Show Concerning
              <input
                id="only-show-concerning-checkbox"
                type="checkbox"
                checked={concerningMetricsOnly}
                onChange={e => setConcerningMetricsOnly(e.target.checked)}
                style={{ margin: '0 10px', verticalAlign: 'middle' }}
              />
            </label>
            <label>
              Only Show Latest
              <input
                id="only-show-latest-checkbox"
                type="checkbox"
                checked={latestMetricsOnly}
                onChange={e => setLatestMetricsOnly(e.target.checked)}
                style={{ margin: '0 10px', verticalAlign: 'middle' }}
              />
            </label>
            <label>
              Show NCF/CCF Complement
              <input
                id="show-complement-checkbox"
                type="checkbox"
                checked={ccfNcfOrder.other !== undefined}
                onChange={e => setShowBuildComplement(e.target.checked)}
                style={{ margin: '0 10px', verticalAlign: 'middle' }}
              />
            </label>
            <label>
              Show Sources
              <input
                id="show-sources-checkbox"
                type="checkbox"
                checked={showSources}
                onChange={e => setShowSources(e.target.checked)}
                style={{ margin: '0 10px', verticalAlign: 'middle' }}
              />
            </label>
            {
              showExpected ?
                <Glyphicon
                  glyph="refresh"
                  onClick={refreshScans}
                /> :
                null
            }
          </div>
        </Panel.Title>
      </Panel.Heading>
      <Collapse in={metricsExpanded}>
        <div>
          <Row className="padded">
            <Col md={6}>
              <Panel bsStyle={badge.style}>
                <Panel.Heading>
                  <Panel.Title>
                    { `Duration ${unicode.DELTA}%` }
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  <DurationBarChartContainer />
                </Panel.Body>
              </Panel>
            </Col>
            <Col md={6}>
              <Panel bsStyle={hitCountStyle}>
                <Panel.Heading>
                  <Panel.Title>
                    { 'Hit Count Difference' }
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  <HitCountChartContainer />
                </Panel.Body>
              </Panel>
            </Col>
          </Row>
          {
            showSources &&
              <Row className="padded">
                <Col md={6}>
                  <Panel bsStyle={hitCountStyle}>
                    <Panel.Heading>
                      <Panel.Title>
                        { 'Source Count Difference' }
                      </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                      <SourceCountChartContainer />
                    </Panel.Body>
                  </Panel>
                </Col>
                <Col md={6}>
                  <Panel bsStyle={hitCountStyle}>
                    <Panel.Heading>
                      <Panel.Title>
                        { 'Source Attribute Count Difference' }
                      </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                      <SourceAttributeCountChartContainer />
                    </Panel.Body>
                  </Panel>
                </Col>
              </Row>
          }

          <Row className="padded">
            <Col md={12}>
              {showExpected ?
                <Row className="padded">
                  <Col md={6} mdOffset={6}>
                    <Button
                      block
                      disabled={!metrics.length}
                      onClick={() => onOpenConfirm(metrics, ccfNcfOrder, showSources)}
                    >
                      Expect All Hits
                    </Button>
                  </Col>
                </Row> :
                null }
              <MetricsTableContainer />
            </Col>
          </Row>
        </div>
      </Collapse>
    </Panel>
  );
};

BuildMetricsComponent.propTypes = {
  baselineBuildType: PropTypes.string.isRequired,
  onShowStatsModal: PropTypes.func.isRequired,
  metricsExpanded: PropTypes.bool.isRequired,
  setMetricsExpanded: PropTypes.func.isRequired,
  latestMetricsOnly: PropTypes.bool,
  setLatestMetricsOnly: PropTypes.func.isRequired,
  concerningMetricsOnly: PropTypes.bool,
  setConcerningMetricsOnly: PropTypes.func.isRequired,
  refreshScans: PropTypes.func.isRequired,
  metrics: PropTypes.array.isRequired,
  metricsLoaded: PropTypes.bool,
  onOpenConfirm: PropTypes.func.isRequired,
  ccfNcfOrder: PropTypes.shape({
    main: PropTypes.string.isRequired,
    other: PropTypes.string
  }).isRequired,
  setShowBuildComplement: PropTypes.func.isRequired,
  showSources: PropTypes.bool.isRequired,
  setShowSources: PropTypes.func.isRequired
};

export default BuildMetricsComponent;


// WEBPACK FOOTER //
// src/Components/BuildMetricsComponent.jsx